import { getTemplatesListSearchParams } from '../hooks/use-load-paginated-templates-and-theme-packs';
import { store } from '@/store/main';
import { fetchThemesAndTemplates } from '@/store/slices/templates';
import { PAGINATION_LIMIT } from '@/utils/pagination-constants';
import { waitForChannelId } from './async-utils/await-channel';

export const loadTemplates = async (request: Request) => {
  const channel = await waitForChannelId();
  const url = new URL(request.url);
  const { page, designParam, categoriesParam, searchQuery, groupParam, favoritesParam, offset, recentParam } =
    getTemplatesListSearchParams({ searchParams: url.searchParams });

  store.dispatch(
    fetchThemesAndTemplates({
      channel,
      returnStoreStateIfExists: false,
      search: searchQuery,
      offset,
      limit: PAGINATION_LIMIT,
      includeTemplatesChannel: recentParam ? true : page === 1,
      noV1Events: true,
      templateFilters: {
        design: designParam,
        categories: categoriesParam,
        favorites: favoritesParam,
        recent: recentParam,
      },
      groupUuid: groupParam,
    })
  );
};
